export default "__VITE_ASSET__bbeebb3e__"